<div class="ot-form-control ot-mb-0" >
  <label [for]="identifier" class="ot-form-control__label" i18n>
        Variable name
    </label>
  <div class="ot-dropdown" [ngClass]="{'ot-dropdown--is-active': showList}">
    <div class="ot-form-control" style="margin-bottom:5px; width: 100%;">
      <input [id]="identifier" #variableInputText type="text" placeholder="Enter a new variable name or search existing variables" i18n-placeholder maxLength="25" class="ot-input" [(ngModel)]="queryText" (focus)="showList=true" (keyup.enter)="onEnterKeyPressed()" autocomplete="off">
    </div>
    @if (showList) {
      <ul class="ot-dropdown__menu" style="max-width: unset;width: auto;" >
        @if (variables | filterBy:'type':type | containsBy:['name']:queryText; as filteredVariables) {
          @for (v of filteredVariables; track v) {
            <li class="ot-dropdown__item" (click)="onVariableSelected(v)">
              <div [innerHtml]="v.name | highlightText : queryText"></div>
            </li>
          }
          @if (!filteredVariables.length && (queryText && queryText != '')) {
            <ng-container [ngTemplateOutlet]="noVariables"></ng-container>
          }
        } @else {
          <li class="ot-dropdown__item" (click)="onNewVariableSelected(queryText)">
            <span >{{queryText}}</span>
          </li>
        }
        <ng-template #noVariables>
          <li class="ot-dropdown__item" (click)="onNewVariableSelected(queryText)">
            <span >{{queryText}}</span>
          </li>
        </ng-template>
      </ul>
    }
  </div>
  <div class="ot-chips ot-pl-0">
    @if (variableName) {
      <div class="ot-chip" style="margin-left:0px">
        {{variableName}}
        <button class="ot-chip__close" (click)="onRemoveVariableBtnClicked(variableName)" title="Remove" title-i18n></button>
      </div>
    }
  </div>
</div>